/** Geometria del grafico de sectores, aparte del componente para poder probarla. */

export const RADIO_EXTERIOR = 100
export const RADIO_INTERIOR = 62

/** Hueco angular entre porciones: el separador de 2px que exige la guia. */
const HUECO_MAX = 0.018

/**
 * Path SVG de un sector de corona circular.
 * @returns {string} vacio si la porcion es demasiado fina para dibujarse.
 */
export function arcoSector(inicio, fin, re = RADIO_EXTERIOR, ri = RADIO_INTERIOR) {
  if (!Number.isFinite(inicio) || !Number.isFinite(fin) || fin <= inicio) return ''
  const hueco = Math.min(HUECO_MAX, (fin - inicio) / 4)
  const a0 = inicio + hueco
  const a1 = fin - hueco
  if (a1 <= a0) return ''
  const largo = a1 - a0 > Math.PI ? 1 : 0
  const p = (r, a) => `${(r * Math.cos(a)).toFixed(2)} ${(r * Math.sin(a)).toFixed(2)}`
  return [
    `M ${p(re, a0)}`,
    `A ${re} ${re} 0 ${largo} 1 ${p(re, a1)}`,
    `L ${p(ri, a1)}`,
    `A ${ri} ${ri} 0 ${largo} 0 ${p(ri, a0)}`,
    'Z',
  ].join(' ')
}

/**
 * Convierte valores en sectores consecutivos empezando arriba (12 en punto).
 * @param {Array<{value: number}>} items
 */
export function repartirAngulos(items) {
  const total = items.reduce((s, i) => s + (i.value > 0 ? i.value : 0), 0)
  if (!total) return items.map((i) => ({ ...i, fraccion: 0, d: '' }))

  let angulo = -Math.PI / 2
  return items.map((item) => {
    const fraccion = Math.max(0, item.value) / total
    const inicio = angulo
    const fin = angulo + fraccion * Math.PI * 2
    angulo = fin
    return { ...item, fraccion, d: arcoSector(inicio, fin) }
  })
}
